import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
const TYPE = 'recovr.AutomaticLocationTransferCard';
function create() {
  return {
    id: v4(),
    type: TYPE,
    height: 'auto'
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('height'),
  getSettingsPath: model => {
    return `${model.type}.${model.id}`;
  }
};